import { useContext, useEffect, useRef } from "react";
import { PinGenerationStatus, ResponseContext } from "@swiggy-private/portal-dineout-context";
import { ingestPinInMenuResponse } from "../utils/menu";

export const usePinInjection = () => {
    const { state, dispatch } = useContext(ResponseContext);
    const lastInjectedPinRef = useRef<string | null>(null);

    // Inject pin whenever pin data changes and menu data exists
    // This handles the case where pin arrives after menu is already loaded
    useEffect(() => {
        const hasPinData = Boolean(state.pin?.data?.status);
        const pinKey = `${state.pin?.data?.pin}-${state.pin?.data?.status}`;

        // Inject pin if we have pin data and menu data, and haven't injected this pin yet
        if (hasPinData && state.menu.initialData && lastInjectedPinRef.current !== pinKey) {
            lastInjectedPinRef.current = pinKey;
            ingestPinInMenuResponse(
                state.menu.initialData,
                {
                    selectedTab: state.menu.parentType || "",
                    pin: state.pin.data.pin,
                    tableNo: state.pin.data.tableNo,
                    status: state.pin.data.status as PinGenerationStatus,
                },
                dispatch,
            );
        }

        // Reset pin injection flag when pin data is cleared
        if (!hasPinData) {
            lastInjectedPinRef.current = null;
        }
    }, [state.pin.data, state.menu.initialData, state.menu.parentType, dispatch]);
};
